/* eslint-disable no-console, react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro'
import { Button, Spacer } from 'components/atoms';
import { InputIcon, Pagination } from 'components/molecules';
import { MediaGallery } from 'components/organisms';
import { modifiersType } from 'types';
import { getImages, IMAGES_KEY } from 'services/requests';
import { useDebounce } from 'react-use'
import { useParams } from 'react-router-dom';
import { usePaginatedQuery } from 'react-query'

const pageSize = 12

const MediaGalleryContainer = ({
  onSelect,
  modifiers,
  isInput,
  forceUpdate,
  onClickUpload,
  onlyEditable,
  activeForm
}) => {
  // eslint-disable-next-line no-unused-vars
  const [allData, setAllData] = useState([]);
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [page, setPage] = useState(1)
  const { subweb } = useParams();
  useDebounce(
    () => {
      if (debouncedSearch !== search) setDebouncedSearch(search);
    },
    350,
    [search]
  );

  const {
    isLoading,
    isFetching,
    resolvedData,
    refetch
  } = usePaginatedQuery([IMAGES_KEY, {
    currentPage: page,
    recordsPerPage: pageSize,
    subweb,
    search: debouncedSearch,
    pagination: true,
    onlyEditable
  }], getImages, {
    
  })

  const totalRecords = React.useMemo(
    () => (
      resolvedData && resolvedData.data
        && resolvedData.data.pagination && resolvedData.data.pagination.totalRecords
        ? resolvedData.data.pagination.totalRecords
        : 0
    ),
    [resolvedData])

  React.useEffect(() => {
    // console.log({ totalRecords, resolvedData })
  }, [totalRecords])

  const images = useMemo(() => {
    if (
      resolvedData
      && resolvedData.data
      && resolvedData.data.files
      && resolvedData.data.files.length > 0
    ) {
      return resolvedData.data.files;
    }
    return [];
  }, [resolvedData]);

  const handleSearch = (e) => {
    const searchValue = e.target.value
    setSearch(searchValue)
    setPage(1)
  }

  // HACK:
  // the carousel height was not adjusting when the images loaded up
  // this fixes that
  React.useEffect(() => {
    refetch()
    forceUpdate()
  }, [images, activeForm])

  const handleClickUpload = (e) => {
    e.stopPropagation();
    onClickUpload()
  }

  return (
    <>
      <Top>
        <Top.Start>
          <InputIcon
            isLoading={isLoading || isFetching}
            icon="search"
            placeholder="pesquisar imagens"
            value={search}
            onChange={handleSearch}
            modifiers={['stretch']}
          />
        </Top.Start>
        <Top.End>
          <Button modifiers={['dark', 'smallText']} onClick={handleClickUpload}>nova imagem</Button>
        </Top.End>
      </Top>
      <List>
        <Spacer bottom="m">
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
            pageSize={pageSize}
          />
        </Spacer>
        <MediaGallery
          isLoading={isLoading}
          images={images}
          onSelect={onSelect}
          modifiers={modifiers}
          isInput={isInput}
          search={debouncedSearch}
        />
        <Spacer top="m">
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
            pageSize={pageSize}
          />
        </Spacer>
      </List>
    </>
  );
};

const Top = styled.div`
  width: 100%;
  padding-bottom: ${props => props.theme.spacing.l};
  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: ${props => props.theme.spacing.xs};
  padding-right: ${props => props.theme.spacing.xl2};
`;

Top.Start = styled.div``;
Top.End = styled.div`
  button {
    height: 100%;
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`

MediaGalleryContainer.propTypes = {
  onSelect: PropTypes.func,
  forceUpdate: PropTypes.func,
  onClickUpload: PropTypes.func,
  modifiers: modifiersType,
  isInput: PropTypes.bool,
  onlyEditable: PropTypes.bool,
  activeForm: PropTypes.number,
};

MediaGalleryContainer.defaultProps = {
  onSelect: () => null,
  forceUpdate: () => null,
  onClickUpload: () => null,
  modifiers: [],
  isInput: false,
  onlyEditable: false,
  activeForm: 0
};

export default MediaGalleryContainer;
